"use strict";
var _1 = require("./");
var ApiTraveler = (function () {
    function ApiTraveler(isPrimary) {
        if (isPrimary === void 0) { isPrimary = false; }
        this.firstName = '';
        this.lastName = '';
        this.birthDate = '';
        this.gender = '';
        this.phoneNumber = '';
        this.email = '';
        this.address = new _1.ApiAddress();
        this.isPrimary = false;
        this.tripCost = null;
        this.relationship = '';
        this.age = null;
        this.loadedFromQuote = false;
        this.isPrimary = isPrimary;
    }
    return ApiTraveler;
}());
exports.ApiTraveler = ApiTraveler;
//# sourceMappingURL=D:/a/1/s/base/src/models/api-traveler.model.js.map


// WEBPACK FOOTER //
// ./~/@bhtp-client-api/base/src/models/api-traveler.model.js